module.exports = __webpack_public_path__ + "528f33438d56873340dcf396ba8dfec1.svg";